import script from "./TradingAccountsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingAccountsList.vue?vue&type=script&setup=true&lang=js"

import "./TradingAccountsList.vue?vue&type=style&index=0&id=7c479678&lang=css"

const __exports__ = script;

export default __exports__